import { render, staticRenderFns } from "./StepHeaderClose.vue?vue&type=template&id=2c86ed5e&scoped=true"
import script from "./StepHeaderClose.vue?vue&type=script&lang=js"
export * from "./StepHeaderClose.vue?vue&type=script&lang=js"
import style0 from "./StepHeaderClose.vue?vue&type=style&index=0&id=2c86ed5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c86ed5e",
  null
  
)

export default component.exports